module.exports = __webpack_public_path__ + "static/media/logo-purple.d2a09b2f.svg";